import React from 'react';
import { Link } from 'react-router-dom';

const RegistrationClosed = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '1rem',
      background: 'linear-gradient(135deg, #0d3b0d 0%, #1a5319 100%)',
    }}
  >
    <div
      style={{
        background: '#123a12',
        border: '1px solid rgba(255,255,255,0.15)',
        borderRadius: '16px',
        padding: '2.5rem 2rem',
        maxWidth: '480px',
        textAlign: 'center',
        color: '#e8f5e8',
      }}
    >
      <div style={{ fontSize: '3rem' }}>🔒</div>
      <h2 style={{ color: '#ffd700', margin: '0.75rem 0' }}>Registration Closed</h2>
      <p style={{ lineHeight: 1.6 }}>
        New registrations are closed on the test platform.
        <br />
        Existing accounts are unaffected.
      </p>
      <p style={{ lineHeight: 1.6, marginTop: '0.75rem' }}>
        If you need an account, please contact your admin.
      </p>
      <Link
        to="/login"
        style={{
          display: 'inline-block',
          marginTop: '1.5rem',
          color: '#ffd700',
          fontWeight: 700,
          textDecoration: 'none',
        }}
      >
        Back to Login
      </Link>
    </div>
  </div>
);

export default RegistrationClosed;
